import React, { useEffect, useState } from 'react'

function DescriptionMember() {
    const [relatedMembers, setrelatedMembers] = useState([1,2,3,4,5,6,7,8,9])

  return (
    <div className='flex justify-center' style={{ height: '100%', width: '100%' }}>
    <div className='lg:w-full w-full flex lg:flex-row flex-col '>
        {/* Description */}
        <div className='flex flex-col lg:w-8/12 w-full '>
            <div className='lg:text-left text-center'><h2 className='text-xl font-semibold'>Budget Presentation</h2></div>
            <div className='lg:w-10/12 w-11/12 lg:text-left text-center '><p className='mt-6 lg:ms-0 ms-8'>Lorem ipsum dolor sit amet consectetur adipisicing elit. Doloribus quia, esse nulla id quibusdam corrupti saepe atque libero! Accusantium beatae obcaecati perspiciatis ratione ex alias excepturi unde at aspernatur accusamus.</p></div>
            <div className='mt-6 flex flex-row lg:w-5/12 w-10/12 justify-between lg:text-left text-left lg:ms-0 ms-8' style={{ color: '#606060' }}>
                <div className='flex flex-col ' >
                    <p  >Department</p>
                    <p className='mt-5'>Place</p>
                    <p className='mt-5'>District</p>
                    <p className='mt-5'>Constituency</p>
                    <p className='mt-5'>Elected Date</p>
                    {/* <p className='mt-5'>Views Count</p> */}
                </div>

                <div className='flex flex-col'>
                    <p>15 th</p>
                    <p className='mt-5'>Chief Minister</p>
                    <p className='mt-5'>Pinarayi</p>
                    <p className='mt-5'>Kannur</p>
                    <p className='mt-5'>Dharmadam</p>
                    {/* <p className='mt-5'>1.45k</p> */}

                </div>
            </div>




        </div>

        {/* Related members */}
        <div className='flex lg:w-4/12 w-11/12 lg:mt-0 mt-6 '>
            <div className='flex flex-col w-full '>
                <div className='flex justify-center mb-2 lg:ms-0 ms-8 '><h5>Members</h5></div>
                
                <div className='flex justify-center mt-2 mb-2 lg:ms-0 ms-8 border-b'><div className='w-5 h-1 bg-primary rounded-xl mb-2'></div></div>

               <div className='w-full h-96 overflow-hidden overflow-y-scroll hide-scroll-bar border-b'>
                 <div className='flex justify-end flex-col mt-4 lg:ms-0 ms-8' >
                     {relatedMembers?.map((members, index) => (
                         <div key={index} className='w-full h-24 flex justify-around items-center mb-3 border hover:shadow-xl' style={{ borderRadius: '14px', border: '1px solid #001F33' }}>
                             <div><img src="https://ministersandgovernors.com/wp-content/uploads/2020/03/Pinarayi-Vijayan.jpg" alt="Profie" className='w-20 h-20 rounded-full' /></div>
                
                             <div className='flex flex-col'>
                                 <div><h4 className=''>Pinarayi Vijayan</h4></div>
                                 <div><p style={{ color: '#878787' }}>Chief Minister</p></div>
                             </div>
                         </div>
                     ))}
                
                 </div>
                
               </div>
                {/* <div className='flex justify-end me-2 text-blue-800 cursor-pointer mt-4' onClick={handleSeeMore}>{!isSeeMore ? 'See More' : 'See Less'}</div> */}
                    {/* <div className='flex justify-center mt-2 lg:ms-0 ms-8'><div className='w-4 h-1 bg-blue-gray-900 rounded-xl '></div></div> */}


            </div>
        </div>


    </div>


</div>  )
}

export default DescriptionMember